import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Alert/style";
import _Alert from "@arco-design/web-react/es/Alert";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import { intl } from 'di18n-react';
import React, { useRef, useState } from 'react';
import styles from './style/index.module.less';
import formStyles from '@/style/form.module.less';
import cs from 'classnames';
import { login } from '@/services/login';
import useStorage from '@/utils/useStorage';
import { useHistory } from 'react-router';
import { useRequest } from 'ahooks';
const {
  Password
} = _Input;
export default function LoginForm() {
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [, setStorage] = useStorage('nms_userStatus');
  const [, setUserNameStorage] = useStorage('nms_userName');
  const [, setToken] = useStorage('nms_token');
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState('');
  const [name, setName] = useState('');
  const {
    run: loginRun,
    loading: loginLoading
  } = useRequest(login, {
    manual: true,
    onSuccess: res => {
      setStorage('login');
      setUserNameStorage(name);
      setErrorMessage('');
      history.push('/');
      setToken(res.token);
    }
  });
  async function loginSubmit({
    username,
    password
  }) {
    if (!username?.trim() || !password?.trim()) {
      return;
    }
    loginRun({
      username,
      password: password
    });
  }
  function onSubmitClick() {
    formRef.current.validate().then(values => {
      loginSubmit(values);
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-title']
  }, intl.t('欢迎使用 Node Master')), !!errorMessage && /*#__PURE__*/React.createElement(_Alert, {
    type: "error",
    content: errorMessage,
    style: {
      border: '1px solid var(--color-danger-light-2)'
    }
  }), /*#__PURE__*/React.createElement(_Form, {
    className: cs(styles['login-form'], formStyles.form),
    layout: "vertical",
    ref: formRef
    // labelCol={{
    //   flex: '200px',
    // }}
    // wrapperCol={{
    //   flex: 1,
    // }}
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "username",
    label: intl.t('用户名:'),
    style: {
      marginBottom: '30px'
    }
  }, /*#__PURE__*/React.createElement(_Input, {
    onPressEnter: onSubmitClick,
    height: 40,
    autoComplete: "off",
    onChange: value => {
      setName(value);
    }
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "password",
    label: intl.t('密码:')
  }, /*#__PURE__*/React.createElement(Password, {
    onPressEnter: onSubmitClick,
    height: 40,
    visibilityToggle: false
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 20,
    direction: "vertical",
    style: {
      paddingTop: '30px'
    }
  }, /*#__PURE__*/React.createElement(_Button, {
    long: true,
    onClick: onSubmitClick,
    loading: loginLoading,
    className: cs(styles['login-form-btn'], styles.login)
  }, intl.t('登 录')))));
}